define('lib/backbone/Backbone.Mixins.PodioCollectionDateComparator',['require','underscore','lib/Podio.Time'],function (require) {

  var _ = require('underscore');
  var podioTime = require('lib/Podio.Time');

  return {
    comparator: function(aModel, bModel) {
      var attribute = this.dateComparatorAttribute;

      var getDate = function(model) {
        return _.isFunction(model[attribute]) ?
          model[attribute]() :
          model.get(attribute);
      };

      var aDateString = getDate(aModel);
      var bDateString = getDate(bModel);

      if (aDateString && bDateString) {
        var aDate = podioTime.localMomentFromString(aDateString);
        var bDate = podioTime.localMomentFromString(bDateString);

        if (aDate.isAfter(bDate)) {
          return this.reverseSort ? 1 : -1;
        } else if (aDate.isBefore(bDate)) {
          return this.reverseSort ? -1 : 1;
        } else {
          return 0;
        }

      } else {
        return 0;
      }
    }
  };
});

